import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default register('page-manuals', {
  onLoad() {
    const $slider = this.container.querySelector('.page-manuals__carousel');

    new Flickity($slider, {
      freeScroll: false,
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      imagesLoaded: true,
      cellAlign: 'left',
      watchCSS: true,
      wrapAround: false,
      groupCells: true,
    });
  },
});
